import axios from 'axios'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const POLICY_TEMPLATES_URL = `${ROOT}/secure/policy/template/group`

export function fetchPolicyTemplateGroupList({ policyType }) {
  return axios.get(POLICY_TEMPLATES_URL, { params: { policyType } })
}

export function fetchPolicyTemplateGroup({ groupId }) {
  return axios.get(`${POLICY_TEMPLATES_URL}/${groupId}`)
}

export function deletePolicyTemplateGroup({ groupId }) {
  return axios.delete(`${POLICY_TEMPLATES_URL}/${groupId}`)
}

export function updatePolicyTemplateGroup({ groupId, data }) {
  return axios.put(`${POLICY_TEMPLATES_URL}/${groupId}`, data)
}

export function createPolicyTemplateGroup({ data }) {
  return axios.post(POLICY_TEMPLATES_URL, data)
}
